function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M18.731,5.39a6.7,6.7,0,0,0-.426-2.224A4.7,4.7,0,0,0,15.623.484,6.716,6.716,0,0,0,13.4.057C12.417.011,12.106,0,9.617,0s-2.8.011-3.778.054A6.7,6.7,0,0,0,3.615.48,4.473,4.473,0,0,0,1.989,1.54,4.514,4.514,0,0,0,.932,3.162,6.717,6.717,0,0,0,.506,5.386C.459,6.368.449,6.679.449,9.168s.011,2.8.054,3.778a6.7,6.7,0,0,0,.426,2.224,4.7,4.7,0,0,0,2.682,2.682,6.717,6.717,0,0,0,2.224.426c.978.043,1.289.054,3.778.054s2.8-.011,3.778-.054a6.7,6.7,0,0,0,2.224-.426A4.689,4.689,0,0,0,18.3,15.171a6.721,6.721,0,0,0,.426-2.224c.043-.978.054-1.289.054-3.778s0-2.8-.047-3.778ZM17.08,12.875a5.025,5.025,0,0,1-.315,1.7,3.041,3.041,0,0,1-1.741,1.741,5.043,5.043,0,0,1-1.7.315c-.967.043-1.257.054-3.7.054s-2.74-.011-3.7-.054a5.022,5.022,0,0,1-1.7-.315,2.821,2.821,0,0,1-1.053-.684,2.85,2.85,0,0,1-.684-1.053,5.044,5.044,0,0,1-.315-1.7c-.043-.967-.054-1.257-.054-3.7s.011-2.74.054-3.7a5.022,5.022,0,0,1,.315-1.7,2.786,2.786,0,0,1,.688-1.053A2.846,2.846,0,0,1,4.22,2.034a5.046,5.046,0,0,1,1.7-.315c.967-.043,1.257-.054,3.7-.054s2.74.011,3.7.054a5.025,5.025,0,0,1,1.7.315,2.819,2.819,0,0,1,1.053.684,2.85,2.85,0,0,1,.684,1.053,5.045,5.045,0,0,1,.315,1.7c.043.967.054,1.257.054,3.7s-.011,2.733-.054,3.7Zm0,0",
  transform: "translate(-0.449 0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M129.658,124.5a4.709,4.709,0,1,0,4.709,4.709A4.711,4.711,0,0,0,129.658,124.5Zm0,7.764a3.055,3.055,0,1,1,3.055-3.055A3.055,3.055,0,0,1,129.658,132.264Zm0,0",
  transform: "translate(-120.49 -120.041)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M364.649,89.7a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,364.649,89.7Zm0,0",
  transform: "translate(-349.485 -85.429)"
});

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.329,
    height: 18.333,
    viewBox: "0 0 18.329 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2d0c56db.svg";
export { ForwardRef as ReactComponent };